import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./BranchesUIHelpers";

const BranchesUIContext = createContext();

export function useBranchesUIContext() {
  return useContext(BranchesUIContext);
}

export const BranchesUIConsumer = BranchesUIContext.Consumer;

export function BranchesUIProvider({ branchesUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    openNewBranchPage: branchesUIEvents.openNewBranchPage,
    openEditBranchPage: branchesUIEvents.openEditBranchPage
  };

  return (
    <BranchesUIContext.Provider value={value}>
      {children}
    </BranchesUIContext.Provider>
  );
}